import {useMutation} from 'react-query';
import {countriesService} from '../../../../shared/services/configuration/countries';

export const useGetRegion = () => {
  return useMutation((regionId: string) => {
    return countriesService.getRegion(regionId);
  });
};
